// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiServerDatabases
 */
export interface ApiServerDatabases {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiServerDatabases
   */
  databaseIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiServerDatabases
   */
  multiDatabase?: boolean;
}

/**
 * Check if a given object implements the ApiServerDatabases interface.
 */
export function instanceOfApiServerDatabases(
  value: object,
): value is ApiServerDatabases {
  return true;
}

export function ApiServerDatabasesFromJSON(json: any): ApiServerDatabases {
  return ApiServerDatabasesFromJSONTyped(json, false);
}

export function ApiServerDatabasesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiServerDatabases {
  if (json == null) {
    return json;
  }
  return {
    databaseIds:
      json['database_ids'] == null ? undefined : json['database_ids'],
    multiDatabase:
      json['multi_database'] == null ? undefined : json['multi_database'],
  };
}

export function ApiServerDatabasesToJSON(json: any): ApiServerDatabases {
  return ApiServerDatabasesToJSONTyped(json, false);
}

export function ApiServerDatabasesToJSONTyped(
  value?: ApiServerDatabases | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    database_ids: value['databaseIds'],
    multi_database: value['multiDatabase'],
  };
}
